import axiosInstance from "../../api/axiosConfig";

export const getProducts = () => {
  return axiosInstance.get("/home/products/trending");
};
